import * as React from "react";
import * as Immutable from "immutable";
import CommentModel from "../models/CommentModel";
import Context from "./Context";
import DateHelper from "../helpers/DateHelper";
import "./CommentUser.styl";

export default class CommentUser extends React.PureComponent<{
    comment: CommentModel;
    authors: Immutable.Set<number>;
    badges: boolean;
}> {

    public render(): React.ReactNode {
        const comment = this.props.comment;
        return (
            <Context.Consumer>
                {({dispatch, locale, translate}) => (
                    <div className="Discussion-CommentUser-Root">
                        <div className="Discussion-CommentUser-Avatar">
                            {this.renderAvatar()}
                            {this.renderPremium(translate)}
                        </div>
                        <div className="Discussion-CommentUser-NameAndTimestamp">
                            <div className="Discussion-CommentUser-Name">{this.renderName()}</div>
                            <div className="Discussion-CommentUser-BadgeAndTimestamp">
                                {this.renderBadge(translate)}
                                <div className="Discussion-CommentUser-Timestamp">
                                    {DateHelper.format(comment.getTimestamp(), locale)}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </Context.Consumer>
        );
    }

    private renderBadge(translate: any): React.ReactNode {
        const comment = this.props.comment;
        const user = comment.getUser();
        if (this.props.badges) {
            if (user && this.props.authors.contains(user.getId())) {
                return (
                    <div className="Discussion-CommentUser-Badge">
                        {translate("COMMENT_AUTHOR")}
                    </div>
                );
            }
            if (user && user.getBadge() != "") {
                return (
                    <div className="Discussion-CommentUser-Badge">
                        {user.getBadge()}
                    </div>
                );
            }
        }
        return null;
    }

    private renderName(): React.ReactNode {
        const comment = this.props.comment;
        const user = comment.getUser();
        if (user && user.getName() != "") {
            return (
                <a href={"https://refresher.sk/profil/" + user.getNick()}>
                    {user.getName()}
                </a>
            );
        } else if (comment.getUserName() != "") {
            return comment.getUserName();
        } else {
            return "⠀";
        }
    }

    private renderAvatar(): React.ReactNode {
        const comment = this.props.comment;
        const user = comment.getUser();
        if (user && user.getAvatar() != "") {
            return (
                <a href={"https://refresher.sk/profil/" + user.getNick()} title={user.getName()}>
                    <img alt={user.getName()} src={user.getAvatar()} width={30} height={30}/>
                </a>
            );
        } else {
            return (
                <img src="https://refresher.sk/static/css/img/no-avatar.png" width={30} height={30}/>
            );
        }
    }

    private renderPremium(translate: (key: string) => string): React.ReactNode {
        const comment = this.props.comment;
        const user = comment.getUser();
        if (user && user.hasPremium()) {
            return (
                <div className="Discussion-CommentUser-Premium" title={translate("TOOLTIP_PREMIUM")}/>
            );
        }
        return null;
    }

}